import React from 'react';
import type { FC } from 'react';
import { forwardRef } from 'react';

import { FieldFormGroupProps, FieldFormGroup } from '@shared/components/fields/field_form_group';

import { TagsFormControlProps, TagsFormControl } from './tags_form_control';

export type TagsFormGroupType = TagsFormControlProps;
export type TagsFormGroupProps = TagsFormControlProps & FieldFormGroupProps;

export const TagsFormGroup: FC<TagsFormGroupProps> = ({ has, help, label, className, ...input }) => (
  <FieldFormGroup has={has} help={help} label={label} className={className} id={input.id}>
    <TagsFormControl {...input} />
  </FieldFormGroup>
);
